import { Status } from "../common/status/status";

export const DOCUMENT_MAX_TOKENS = 1000;

export const STATUSES_TO_NORMALIZE_ANNOTATIONS = [
  Status.ToDo,
  Status.AnnotationToDo,
  Status.InProgress,
  Status.AnnotationInProgress,
  Status.OnHold,
  Status.AnnotationOnHold,
  Status.Error,
  Status.ExportFailed,
];

export const CSV_FILE_TYPES = ["text/csv", "application/csv"];
export const XML_FILE_TYPES = ["text/plain", "text/xml", "application/xml"];

export const PDF_MIME_TYPE = "application/pdf";
export const PNG_MIME_TYPE = "image/png";
export const JPEG_MIME_TYPE = "image/jpeg";

/** Image formats the pipeline OCRs as a single page. */
export const IMAGE_MIME_TYPES = [PNG_MIME_TYPE, JPEG_MIME_TYPE];

/**
 * What a filename claims, used only when a document carries no mime type of its own.
 * Kept in step with `MIME_TYPE_BY_SUFFIX` in the generic library and `BY_SUFFIX` in
 * api-crud's `MimeTypes`.
 */
export const MIME_TYPE_BY_EXTENSION: Record<string, string> = {
  pdf: PDF_MIME_TYPE,
  png: PNG_MIME_TYPE,
  jpg: JPEG_MIME_TYPE,
  jpeg: JPEG_MIME_TYPE,
};
